// @ts-ignore
import {States} from '@dfb/components/input/constants';

export const getStyle = (disabled: boolean = false, hidden: boolean = false, focused: boolean = false, value: any, isValid: boolean): string => {
    let style = '';

    if (!isValid) {
        style += ' ' + States.INVALID;
    }

    if ((focused && !disabled) || (value && value !== '')) {
        style += ' ' + States.FOCUSED;
    }

    if (disabled) {
        style += ' ' + States.DISABLED;
    }
    if (!hidden) {
        style += ' ' + States.VISIBLE;
    }

    return style;
};
